import React, { useState, useEffect } from 'react';
import '../../Css/AjouterRoom.css'; // Import the CSS file

export default function AjouterOrganisme() {
  const [title, setTitle] = useState('');
  const [tauxCom, setTauxCom] = useState('');
  const [error, setError] = useState('');
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('token'); // Get token from localStorage
  const apiUrl = process.env.REACT_APP_API_URL;

  
  const handleTauxComChange = (event) => {
    setTauxCom(event.target.value);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (title === '' || tauxCom === '') {
      setError('Les deux champs doivent être remplis');
      return;
    }

    const url = editId
      ? `${apiUrl}/api/edit/organismes/${editId}`
      : `${apiUrl}/api/organismes`;

    try {
      const response = await fetch(url, {
        method: editId ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ title, tauxCom }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit');
      }

      const newData = await response.json();
      if (editId) {
        // Update existing entry
        setData(data.map(item => (item.id === newData.id ? newData : item)));
      } else {
        // Add new entry
        setData([...data, newData]);
      }
      
      resetForm();
    } catch (error) {
      setError(`${error.message}`);
    }
  };

  const handleEdit = (item) => {
    setTauxCom(item.tauxCom);
    setTitle(item.title);
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    const confirmation = window.confirm("Are you sure you want to delete this item?");
  
    if (!confirmation) {
      return; // If user cancels, do nothing and return early.
    }
    
    const url = `${apiUrl}/api/delete/organismes/${id}`;
    try {
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        throw new Error('Failed to delete');
      }
  
      // Remove deleted item from state
      setData(data.filter(item => item.id !== id));
    } catch (error) {
      console.error('Failed to delete data', error);
    }
  };

  
  const fetchData = async () => {
    try {
      const organismeResponse = await fetch(`${apiUrl}/api/organismes`, {
        headers: {'Authorization': `Bearer ${token}`},
      });

      const organismes = await organismeResponse.json();

      setData(organismes);
    } catch (error) {
      console.error('Failed to fetch data', error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setTitle('');
    setTauxCom('');
    setEditId(null);
    setError('');
  };

  const handleCancel = () => {
    resetForm(); // Reset the form and exit edit mode
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="AjouterRoom">
      {error && <p className="AjouterRoom__error-message">{error}</p>}
      <form onSubmit={handleSubmit} className="AjouterRoom__form">
        <div className="AjouterRoom__form-group">
          <label className="AjouterRoom__label" htmlFor="title">Saisissez le nom de l'organisation</label>
          <input type="text" id="title" className="AjouterRoom__input" value={title} onChange={handleTitleChange} />
        </div>

        <div className="AjouterRoom__form-group">
          <label className="AjouterRoom__label" htmlFor="title">Indiquez le pourcentage de la commission ( % )</label>
          <input 
            type="text" 
            id="title" 
            className="AjouterRoom__input com-length" 
            value={tauxCom} 
            maxLength="2" 
            pattern="^[0-9]{1,2}$"
            onChange={handleTauxComChange} />
        </div>


        <button type="submit" className="AjouterRoom__submit-button">
        Enregistrer
        </button>
        {editId && (
          <button type="button" onClick={handleCancel} className="AjouterRoom__cancel-button">
            Annuler
          </button>
        )}
      </form>

      {loading ? <p>Loading...</p> : (

      <table className="AjouterRoom__data-table">
        <thead>

        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={`${item.id}-${item.title}`}>
              <td>{item.title}</td>
              <td>% {item.tauxCom}</td>
              <td className="AjouterRoom__button">
                <button onClick={() => handleEdit(item)} className="AjouterRoom__edit-button">Mettre à jour</button>
                <button onClick={() => handleDelete(item.id)} className="AjouterRoom__delete-button">Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
    </div>
  );
}
